import { render } from "./KeywordSuggestions.vue?vue&type=template&id=3fa5a6c0"
import script from "./KeywordSuggestions.vue?vue&type=script&lang=js"
export * from "./KeywordSuggestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__